import ReactDOM from 'react-dom/client'
import { PortalProviders } from '@portals/shared/PortalProviders'
import { CustomerPortal } from '@portals/customer/CustomerPortal'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <PortalProviders portal="customer" enableCart>
    <CustomerPortal />
  </PortalProviders>
)
